<template>
  <div class="table-page">
    <search-wrapper>
      <a-row :gutter="20">
        <a-col :xs="24" :sm="24" :md="24" :lg="18" :xl="12" :xxl="8">
          <a-form-item label="业务ID">
            <a-input
              @keyup.enter="handleSearch"
              placeholder="请输入业务ID"
              v-model="subjectId"
              autocomplete="off"
              style="max-width: 352px"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="18" :xl="12" :xxl="8">
          <a-form-item label="推送类型">
            <a-select :allowClear="false" option-filter-prop="children" show-search defaultValue="" v-model="targetTaskType" style="max-width: 345px"
            :dropdownMatchSelectWidth="false">
              <a-select-option value="">全部</a-select-option>
              <a-select-option :key="taskType.value" :value="taskType.value" v-for="taskType in taskTypeList">
                {{ taskType.value + ' | ' + taskType.label  }}
              </a-select-option>
            </a-select>
         <!--   <a-cascader :options="taskTypeList" :value="targetTaskType" @change="handleCascaderChange" placeholder="全部类型"></a-cascader>-->
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="20" :xl="12" :xxl="8">
          <a-form-item label="任务状态">
            <a-select :allowClear="false" defaultValue="" style="width: 340px" v-model="targetTaskStatus">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="0">未推送</a-select-option>
              <a-select-option value="1">已推送</a-select-option>
              <a-select-option value="2">不需要再推送</a-select-option>
              <a-select-option value="3">推送失败</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- <a-col :span="6" :xl="6">
          <a-form-item label="推送环境">
            <a-select :allowClear="false" defaultValue="" style="width: 120px" v-model="targetTaskEnv">
              <a-select-option value="">全部</a-select-option>
              <a-select-option :value=0>测试环境</a-select-option>
              <a-select-option :value=1>生产环境</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
        <a-col :xs="24" :sm="24" :md="24" :lg="20" :xl="12" :xxl="8">
          <a-form-item label="创建时间">
            <a-range-picker :allowClear="false" v-model="dateRange" format="YYYY-MM-DD HH:mm:ss" showTime style="max-width: 340px">
              <a-icon slot="suffixIcon" type="calendar" />
            </a-range-picker>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="20" :xl="9" :xxl="8">
          <a-form-item class="operation-group">
            <a-button icon="search" @click="handleSearch">查询</a-button>
            <a-button class="reset-btn" icon="sync" @click="resetSearch">重置</a-button>
            <a-button class="reset-btn" icon="swap" @click="pushAgain">消息重推</a-button>
          </a-form-item>
        </a-col>
        <!-- <a-col :span="6" >
          <a-form-item class="operation-group">
            <a-button class="reset-btn" icon="swap" @click="pushAgain">消息重推</a-button>
          </a-form-item>
        </a-col> -->
      </a-row>
    </search-wrapper>
    <!-- 分页表格 -->
    <global-table
      ref="table"
      :rowKey="true"
      @selectionChange="onSelectChange"
      :columns="columns"
      :dataRender="loadData"
      :isShowTotal="true"
      style="margin-top: 24px"
      filled
    >
      <template v-slot:actionForApp="{ row, column, index }">
        <a v-if="row.logUrl !== null && row.logUrl !== ''" href="javascript:void(0);" v-downLoad="row.logUrl">查看日志</a>
        <a-popconfirm placement="top" ok-text="确定" cancel-text="取消" okType="danger" @confirm="resetTask(row.taskId)">
          <template slot="title">
            <p>确认要重置任务？</p>
            <p>重置后将重新推送数据，请谨慎操作，避免业务数据被覆盖！</p>
          </template>
          <a-divider type="vertical" />
          <a href="javascript:;">重置任务</a>
        </a-popconfirm>
      </template>
    </global-table>
  </div>
</template>

<script>
import moment from 'moment';
import {
  Button, Row, Col, Form, DatePicker, message,
} from 'ant-design-vue';
import SearchWrapper from '@/components/SearchWrapper';
import GlobalTable from '@/components/GlobalTable';
import {
  getNotificationTaskType, getTaskLogListByPage, updateTask, messagePushAgain,
} from '@/services/modules/my-system';

export default {
  name: 'TaskLog',
  components: {
    SearchWrapper,
    GlobalTable,
    'a-row': Row,
    'a-col': Col,
    'a-button': Button,
    'a-form-item': Form.Item,
    'a-range-picker': DatePicker.RangePicker,
  },
  data() {
    return {
      taskTypeList: [],
      selectedRowKeys: [],
      targetTaskType: '',
      targetTaskStatus: '',
      // targetTaskEnv: '',
      dateRange: this.getInitDateRange(),
      subjectId: null,
    };
  },
  mounted() {
    this.getNotificationTaskType();
  },
  computed: {
    columns() {
      return [
        {
          key: 'taskId',
          type: 'selection',
          maxWidth: 200,
          minWidth: 100,
        },
        {
          title: '业务ID',
          key: 'subjectId',
          align: 'left',
          minWidth: 200,
        },
        {
          title: '推送类型',
          key: 'taskType',
          align: 'left',
          minWidth: 150,
        },
        {
          title: '任务状态',
          key: 'taskStatusDesc',
          align: 'left',
          minWidth: 120,
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 180,
          align: 'left',
          scopedSlots: { customRender: 'createTime' },
        },
        {
          title: '修改时间',
          key: 'modifyTime',
          minWidth: 180,
          align: 'left',
          scopedSlots: { customRender: 'modifyTime' },
        },
        {
          title: '操作',
          align: 'left',
          fixed: 'right',
          width: 240,
          slot: 'actionForApp',
        },
      ];
    },
    defaultQueryParams() {
      return {
        createBeginTime: this.dateRange[0].format('YYYY-MM-DD HH:mm:ss'),
        createEndTime: this.dateRange[1].format('YYYY-MM-DD HH:mm:ss'),
        taskType: this.targetTaskType,
        taskStatus: this.targetTaskStatus,
        subjectId: this.subjectId == null ? '' : this.subjectId,
        // env: this.targetTaskEnv,
      };
    },
  },
  methods: {
    onSelectChange(selectedRows) {
      console.log('selectedRows changed: ', selectedRows);
      this.selectedRowKeys = selectedRows.map(res => res.taskId);
    },
    async pushAgain() {
      if (this.selectedRowKeys?.length === 0) {
        this.$message.info('请选择需要重新推送的消息');
        return;
      }
      const { success, errorMessage = '' } = await messagePushAgain({
        taskIds: this.selectedRowKeys,
      });
      if (success) {
        message.success('选择的记录已触发重推机制，请稍后留意消息推送记录');
        this.selectedRowKeys = [];
        this.$refs.table.refresh(true);
      } else {
        message.error(errorMessage || '重置失败，请重试');
      }
    },
    async loadData(parameter) {
      const res = await getTaskLogListByPage({ ...parameter, ...this.defaultQueryParams });
      res.result.result = res.result.result.map((item) => ({
        ...item,
        // _disabled: item.taskStatus !== 3,
      }));
      return res;
    },
    getNotificationTaskType() {
      getNotificationTaskType().then((res) => {
        if (res && res.result && res.result.length > 0) {
          this.taskTypeList = res.result;
        }
      });
    },
    resetTask(id) {
      const params = { taskId: id, taskStatus: 0 };
      updateTask(params).then((res) => {
        if (res && res.success && res.result) {
          this.$message.success('重置成功');
          this.$refs.table.refresh(true);
        } else {
          this.$message.error((res && res.errorMessage) || '重置失败，请重试');
        }
      });
    },
    handleCascaderChange(value) {
      this.targetTaskType = value;
    },
    handleSearch() {
      this.$refs.table.refresh(true);
    },
    resetSearch() {
      this.targetTaskType = '';
      this.subjectId = null;
      this.targetTaskStatus = '';
      // this.targetTaskEnv = '';
      this.dateRange = this.getInitDateRange();
      this.handleSearch();
    },
    getInitDateRange() {
      const defaultSelectDate = {
        startDate: moment().startOf('day').subtract(7, 'days'),
        endDate: moment().startOf('day').add(1, 'days').subtract(1, 'seconds'),
      };
      return [defaultSelectDate.startDate, defaultSelectDate.endDate];
    },
    handleCopy(value) {
      this.$copyText(value).then(this.$message.success('复制成功'));
    },
  },
};
</script>

<style lang="less" scoped>
  .table-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    /deep/ .ant-col-8 {
      width: auto;
    }
    /deep/ .ant-col-6 {
      width: auto;
    }
    &__main {
       flex: 1;
       height: 100%;
    }
  }
</style>
